var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "d-flex justify-content-between align-items-center mb-3",
        },
        [
          _c("h5", { staticClass: "mb-0" }, [
            _vm._v(
              _vm._s(_vm.provider.title) +
                "-" +
                _vm._s(_vm.__t("NOTIFICATIONS"))
            ),
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-primary waves-effect waves-themed",
              on: { click: _vm.add_trigger },
            },
            [
              _c("i", { staticClass: "fal fa-plus mr-2" }),
              _vm._v(_vm._s(_vm.__t("CREATE_TRIGGER")) + "\n        "),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _vm._l(_vm.triggers, function (trigger) {
        return _c("order_notification_trigger", {
          key: trigger.id || trigger._uid,
          attrs: { rest: _vm.rest, provider: _vm.provider, trigger: trigger },
          on: { removed: _vm.on_removed, duplicated: _vm.on_duplicated },
        })
      }),
      _vm._v(" "),
      _vm.triggers.length === 0
        ? _c("div", { staticClass: "text-muted" }, [
            _vm._v(
              "\n        " + _vm._s(_vm.__t("NO_TRIGGERS_YET")) + "\n    "
            ),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }